<template>
    <div>
        <div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
            <el-card class="box-card">
                <div slot="header">
                    <el-row style="margin-bottom: 20px">
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item :to="{ path: '/customer' }">首页</el-breadcrumb-item>
                            <el-breadcrumb-item>巡逻记录</el-breadcrumb-item>
                        </el-breadcrumb>
                        <el-col :span="24">
                            <div style="line-height: 3rem; font-size: 1.5rem;">巡逻记录</div>
                        </el-col>

                    </el-row>
                    <el-row style="text-align: left">
                        <el-form :inline="true" :model="searchForm" @keyup.enter.native="searchData">
                            <el-form-item >
                                <el-input @change="changeIndex"   placeholder="用户名" v-model="searchForm.userName" clearable >
                                </el-input>
                            </el-form-item>
                            <!--<el-form-item >-->
                                <!--<el-select clearable style="width: 200px" :disabled="deptdisable" @change="getGd"  filterable v-model="searchForm.bmid"     placeholder="请选择大队">-->
                                    <!--<el-option-->
                                            <!--v-for="item in depts"-->
                                            <!--:key="item.bmid"-->
                                            <!--:label="item.bmmc"-->
                                            <!--:value="item.bmid"-->
                                            <!--:disabled="deptdisable">-->
                                    <!--</el-option>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->
                            <el-form-item >
                                <el-select clearable style="width: 200px" @change="changeIndex"  filterable v-model="searchForm.gdid"     placeholder="请选择岗点">
                                    <el-option
                                            v-for="item in gdList"
                                            :key="item.gdid"
                                            :label="item.gdmc"
                                            :value="item.gdid">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item >
                                <el-date-picker
                                        v-model="startTime"
                                        type="daterange"
                                        @change="changeIndex"
                                        value-format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item >
                                <el-input @change="changeIndex"   placeholder="巡逻点名称" v-model="searchForm.placeName" clearable >
                                </el-input>
                            </el-form-item>
                            <el-form-item >
                                <el-select v-model="searchForm.status" clearable @change="changeIndex"    placeholder="状态">
                                    <el-option  :key="0" :label="'正常'" :value="0"></el-option>
                                    <el-option  :key="1" :label="'异常'" :value="1"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="searchData()">查询</el-button>
                                <!-- <el-button  type="primary" @click="addOrUpdate()" icon="el-icon-plus" style="display: inline;">添加</el-button> -->
                                <!-- <el-button  type="danger" @click="deleteHandle()">批量删除</el-button> -->
                            </el-form-item>
                        </el-form>
                    </el-row>
                </div>

                <el-table
                        :header-cell-class-name="handleHeaderClass"
                        @sort-change="handleTableSort"
                        :data="dataList" @selection-change="selectionChangeHandle" v-loading="loading"  style="text-align: center; width: 100%;">
                    <el-table-column
                            type="selection"
                            header-align="center"
                            align="center"
                            width="50">
                    </el-table-column>
                    <el-table-column prop="t.user_id" label="用户" sortable="custom" >
                        <template slot-scope="scope">
                            {{scope.row.userName}}
                        </template>
                    </el-table-column>

                    <el-table-column prop="workNumber" label="工号"  >
                    </el-table-column>
                    <el-table-column prop="u.zzdyqc" label="部门"  sortable="custom" >
                        <template slot-scope="scope">
                            {{scope.row.bmmc}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="t.status" label="状态" >
                        <template slot-scope="scope">
                            <el-tag type="error" v-if="scope.row.status===1">异常</el-tag>
                            <el-tag  v-else type="success">正常</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="t.place_id" label="巡逻点" sortable="custom" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.plcaeName}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="t.time" label="扫码时间" sortable="custom" >
                        <template slot-scope="scope">
                            {{scope.row.time}}
                        </template>
                    </el-table-column>
<!--                    <el-table-column prop="lon" label="经度" sortable="custom" >-->
<!--                    </el-table-column>-->
<!--                    <el-table-column prop="lat" label="维度" sortable="custom" >-->
<!--                    </el-table-column>-->
                    <el-table-column label="操作" :render-header="renderHeader">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini"   @click="showInfo(scope.row)">详情</el-button>
                            <!-- <el-button type="text" size="mini"   @click="addOrUpdate(scope.row.id)">修改</el-button> -->
                            <!-- <el-button type="text" size="mini"  @click="deleteHandle(scope.row.id)">删除</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentNo"
                               :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                </el-pagination>
                <el-dialog
                        style="text-align: left"
                        title="导出"
                        :visible.sync="exportVisible">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                    <el-checkbox-group v-model="fieldList" @change="handleCheckedItemChange">
                        <el-checkbox v-for="field in fields" :label="field.value" :key="field.value">{{field.name}}</el-checkbox>
                    </el-checkbox-group>
                    <form ref="exportForm" method="post" :action="this.$request.defaults.baseURL+'/bjba/tpatrollog/exportCustomer?access_token='+this.$store.getters.token" target="_blank">
                        <input type="hidden" v-for="(value,key,index) in searchForm" :name="key"  :value="value" />
                        <input type="hidden" name="fileds" value="" ref="fileds"/>
                    </form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="exportVisible = false">取 消</el-button>
                        <el-button type="primary" @click="exportExcel">确 定</el-button>
                    </span>
                </el-dialog>
            </el-card>
        </div>
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="searchData"></add-or-update>
        <show-info v-if="showInfoVisible" ref="showinfo"></show-info>


    </div>
</template>
<script>
    import {
        Vue,
        Component
    } from 'vue-property-decorator'

    import AddOrUpdate from './patrol-log-add-or-update'
    import ShowInfo from './patrol-log-info'
    import Template from "../../../template";
    const exportFields=[
        {name:'工号',value:'workNumber'},
        {name:'用户名',value:'userName'},
        {name:'部门',value:'bmmc'},
        {name:'岗点',value:'gdmc'},
        {name:'巡逻点',value:'plcaeName'},
        // {name:'详细地址',value:'detailPlace'},
        {name:'时间',value:'time'}
    ]
    @Component({
        name: 'tPatrolLog',
        components:{
            Template,
            AddOrUpdate,
            ShowInfo
        }
    })
    export default class tPatrolLog extends Vue {
        addOrUpdateVisible=false
        currentNo = 1;
        pageSize = 10;
        pageTotal = 0;
        dataList=[]
        showInfoVisible=false
        startTime=[]
        searchForm={
            userName:'',
            placeName: '',
            startTimest: '',
            startTimeed: '',
            gdid: '',
            bmid: '',
            orders:'',
            status:'',
            customerId: this.$store.getters.user.customerId
        }
        loading = false;
        dataListSelections=[];
        orders=[]
        exportVisible = false;
        isIndeterminate= false
        checkAll=false;
        fields=exportFields;
        filedValues=exportFields.map(item => item.value);
        fieldList=[];
        gdList = [];
        depts = [];
        deptdisable = false;
        created() {
          this.searchData();
          // this.getDepts()
            this.getGd()
        }
        getDepts() {
            let that = this;
            this.$request.get('/bjba/kqtj/getFirstMentForUser',{
                params: {
                    userid:this.$store.getters.username
                }

            }).then(res => {
                that.depts = res.data
                if(this.depts && this.depts[0]) {
                    var zzdyqc = this.$store.getters.user.zzdyqc;
                    if(zzdyqc != this.CONST_ZN_BM) {
                        var zw = this.$store.getters.user.zw;
                        if(zw) {
                            if(zw=='01'||zw=='02'||zw=='03') {
                                this.searchForm.bmid = that.depts[0].bmid
                                this.deptdisable = true
                                this.getGd()
                                if(zw !='01') {
                                    // this.childdeptdisable =true;
                                }
                                // this.selectChanged2(this.form.dept)
                            }
                        } else {
                            // this.selectChanged2(this.form.dept)
                        }
                    }


                }
            })
        }
        getGd() {
            this.changeIndex()
            this.searchForm.gdid = ''
            this.$request.get('/bjba/map/queryAllByCustomerAndBm',{
                params: {
                    bmid: "",
                    customerId: this.searchForm.customerId
                }
            }).then(res => {
                this.gdList = res.data.data
            })
        }
        handleSizeChange(val) {
            this.pageSize = val;
            this.searchData();
        }
        handleCurrentChange(val) {
            this.currentNo = val;
            this.searchData();
        }
        // 多选
        selectionChangeHandle (val) {
            this.dataListSelections = val
        }
        addOrUpdate(val) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(val)
            })
        }
        showInfo(val) {
            this.showInfoVisible = true
            this.$nextTick(() => {
                this.$refs.showinfo.init(val)
            })
        }
        deleteHandle (id) {
            let ids = id ? [id] : this.dataListSelections.map(item => {
                return item.id
            })
            if(!ids || ids.length==0) return
            this.$confirm(`确定进行[删除]操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: `/bjba/tpatrollog/delete`,
                    method: 'post',
                    data: ids
                }).then(({data}) => {
                    if (data && data.code === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                        })
                        this.searchData()
                    } else if(data && data.code ==500) {
                        this.$message({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                })
            }).catch(() => {
            })
        }
        changeIndex(){
            this.currentNo =1
        }
        getParams() {
            if(this.startTime &&this.startTime.length==2){
                this.searchForm.startTimest = this.startTime[0]
                this.searchForm.startTimeed = this.startTime[1]
            } else{
                this.searchForm.startTimest = ''
                this.searchForm.startTimeed = ''
            }
            this.searchForm.orders = encodeURI(JSON.stringify(this.orders));
            this.searchForm.page = this.currentNo;
            this.searchForm.pagesize = this.pageSize
        }
        searchData () {
            this.loading = true
            this.getParams()
            this.$request.get('/bjba/tpatrollog/khlist',{params:this.searchForm}).then(res => {
                const {data} = res
                this.loading = false
                this.dataList = data.data.content
                this.pageTotal = data.data.totalElements
            }).catch(err => {
                this.$message({
                    message: '获取列表出现异常!',
                    type: 'error',
                    center: true,
                    showClose: true
                })
            this.loading = false
            console.log(err)
            })
        }

        handleOrderChange (orderColumn, orderState) {
            let result = this.orders.find(e => e.orderColumn === orderColumn)
            if (result) {
                if(orderState)
                    result.orderState = orderState
                else {
                    var j =this.orders.indexOf(result);
                    if(j !== -1) {
                        this.orders.splice(j,1);
                    }
                }
            } else {
                this.orders.push({
                    orderColumn: orderColumn,
                    orderState: orderState
                })
            }
            this.searchData()
        }
// 上面缺点是只能通过点击表头切换排序状态，点击小三角排序不会触发，处理sort-change事件和点击表头一样
// 列表排序
        handleTableSort({ column }) {
            column.multiOrder = column.order
            this.handleOrderChange(column.property, column.multiOrder)
        }
        // 设置列的排序为我们自定义的排序
        handleHeaderClass({ column }) {
            if(!column.multiOrder) column.multiOrder =''
            column.order = column.multiOrder
        }
        renderHeader (h) {
            return (
                    <div class="clearfix">
                    <span>操作</span>
                    <el-button style="padding:5px;float:right" size="mini"
            onClick={()=>this.showExportDialog()}>导出</el-button></div>
            )
        }

        showExportDialog() {
            this.exportVisible = true
        }
        handleCheckAllChange(val) {
            this.fieldList = val ? this.filedValues: [];
            this.isIndeterminate = false;
        }
        handleCheckedItemChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.filedValues.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.fields.length;
        }
        exportExcel() {
            var filedLast = this.fields.filter(filed=>{
                return this.fieldList.indexOf(filed.value) !==-1
            })
            if(filedLast && filedLast.length>0) {
                this.getParams();
                this.$refs.fileds.value = JSON.stringify(filedLast)
                this.$refs.exportForm.submit();
            } else {
                this.$message({
                    message: '请选择字段',
                    type: 'error',
                    duration: 1500
                })
                return
            }

            //
        }
    }
</script>
<style lang="scss" scoped>


</style>
